var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 *
 * Usage Example:
 *
 * ```
 *    import {Snackbar} from '@variable/ui-theme/dist/hooks'
 *
 *    const Example = props => {
 *      const [setSkackbar] = Snackbar.useSnackbar;
 *      const onClick = ()=>{
 *        setSkackbar('poped example message here');
 *      }
 *
 *      return <button onClick={onClick}>example button</button>
 *    }
 *
 *    export default Snackbar.snackbarWrapper(Example);
 * ```
 */
import { createContext, useCallback, useState, useContext } from 'react';
import { Alert, Snackbar } from '@mui/material';
var defaultSettings = {
    severity: 'error',
    autoHideDuration: 6000,
    position: { vertical: 'top', horizontal: 'center' }
};
var SnackbarContext = createContext(null);
var useSnackbar = function () {
    var context = useContext(SnackbarContext);
    if (!context) {
        return [function () { console.error('Error: Please wrap the parent with snackbarWrapper'); }];
    }
    return context;
};
var snackbarWrapper = function (ChildCompoent) {
    return function (props) {
        var context = useContext(SnackbarContext);
        if (context) {
            return _jsx(ChildCompoent, __assign({}, props));
        }
        var _a = useState(''), errMessage = _a[0], setErrMessage = _a[1];
        var _b = useState(defaultSettings), params = _b[0], setParams = _b[1];
        var setMessage = useCallback(function (message, params) {
            if (params === void 0) { params = {}; }
            setParams(__assign(__assign({}, defaultSettings), params));
            setErrMessage(message.toString());
        }, []);
        return (_jsxs(SnackbarContext.Provider, __assign({ value: [setMessage] }, { children: [_jsx(ChildCompoent, __assign({}, props)), _jsx(Snackbar, __assign({ open: !!errMessage, autoHideDuration: params.autoHideDuration, anchorOrigin: params.position, onClose: function () { return setErrMessage(''); } }, { children: _jsx(Alert, __assign({ severity: params.severity, action: params.action }, { children: errMessage })) }))] })));
    };
};
export default { snackbarWrapper: snackbarWrapper, useSnackbar: useSnackbar, SnackbarContext: SnackbarContext };
